import React, { useState } from "react";
import QNAHistory from "./QNAHistory";
import chatRenderStyle from "./ChatNodeStyle.module.css";

const RenderJsonUI = ({ data }) => {
  const [questionStack, setQuestionStack] = useState([]);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  const [history, setHistory] = useState([]);

  const handleQuestionClick = (question) => {
    const historyEntry = question.statement ? (
      <div>
        <div className={chatRenderStyle.his_qst}>
          <strong>{question.text}</strong> <span>({question.type})</span>
        </div>
        <div className={chatRenderStyle.his_ans}>
          <p>{question.statement}</p>
        </div>
      </div>
    ) : (
      <div className={chatRenderStyle.his_qst}>
        <p>
          {question.text} <span>({question.type})</span>
        </p>
      </div>
    );

    setHistory((prev) => [...prev, historyEntry]);

    if (question.subQuestions.length > 0) {
      setQuestionStack((prev) => [...prev, question]);
      setCurrentAnswer(null);
    } else if (
      question.type === "Multiple Choice" &&
      question.answers?.length > 0
    ) {
      setQuestionStack([]);
      setCurrentAnswer(question.answers.map((a) => a.text).join("\n"));
    }
  };

  const handleBackClick = () => {
    if (questionStack.length > 1) {
      setQuestionStack((prev) => prev.slice(0, -1));
      setCurrentAnswer(null);
    } else {
      setQuestionStack([]);
    }
  };

  const currentQuestions =
    questionStack.length === 0
      ? [data]
      : questionStack[questionStack.length - 1]?.subQuestions || [];

  return (
    <div className={chatRenderStyle.history_content}>
      <QNAHistory history={history} currentAnswer={currentAnswer} />

      <div className={chatRenderStyle.hist_controlles}>
        {questionStack.length > 0 && (
          <button
            className={chatRenderStyle.backButton}
            onClick={handleBackClick}
          >
            Back
          </button>
        )}

        {!currentAnswer && (
          <div className={chatRenderStyle.controllers}>
            {currentQuestions.map((question, index) => (
              <button
                key={index}
                className={chatRenderStyle.historyQuestiion}
                onClick={() => handleQuestionClick(question)}
              >
                {question.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RenderJsonUI;
